



























import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import IntegrationsService from '../../services/integrations.service';
import {Integration} from '@/types';

@Component({
  components: {
  },
})
export default class DeviceEvents extends Vue {
  private integrations: Integration[] = [{name: '', type: '', channel_details: {headers: {}, url: ''}, configurations: [], enabled: true, payload_version: 2}];

  private async mounted() {
    const integrations = await IntegrationsService.getIntegrations();
    Vue.set(this, 'integrations', integrations);
  }
}

